module.exports = __webpack_public_path__ + "static/img/diease-left.f7fdb831.png";